import { Group } from './types'

/**
 * A "By tags" group is a closed group whose members are the community users carrying the group's tags.
 * Its members are never added or removed by hand, so every screen that edits members checks this.
 */
export const isTaggedGroup = (group?: Pick<Group, 'groupTags'> | null): boolean => !!group?.groupTags?.length
